export default {"src":"/_next/static/media/calender.86da571e.svg","height":15,"width":14,"blurWidth":0,"blurHeight":0};